import _ from 'lodash'

declare global {
  interface Window {
    I18n: {
      translations: Record<string, string>
    }
  }
}

class I18n {
  static t(key: string, params: Record<string, unknown> = {}) {
    let lookupKey = key

    // Handle pluralization when count is provided
    if ('count' in params) {
      const count = params.count as number
      const pluralSuffix = count === 1 ? 'one' : 'other'
      const pluralKey = `${key}.${pluralSuffix}`
      if (window.I18n.translations[pluralKey]) {
        lookupKey = pluralKey
      }
    }

    let result = window.I18n.translations[lookupKey]
    if (_.isEmpty(result)) return key
    if (!_.isEmpty(params)) {
      _.each(params, (value: string, k: string) => {
        const pattern = new RegExp(`%{${k}}`, 'g')
        result = result.replace(pattern, value)
      })
    }
    return result
  }
}

export default I18n